import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["escape", "portal", "print", "theme"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Modal } from '../../internal/components/Modal';
import { ModalFullscreenView } from './ModalFullscreenView';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Компонент для рендера полноэкранного модального окна
 *
 * [Ссылка на макет](https://www.figma.com/design/4UM8zoowH9YGMM7fSK0rhD/%F0%9F%8C%90-Web-Components?node-id=33926-23160)
 *
 * @export
 * @class ModalFullscreen
 * @extends {React.Component<IModalFullscreenProps>}
 */
export function ModalFullscreen(_ref) {
  let {
      escape = true,
      portal = true,
      print = true,
      theme = 'white'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(Modal, _objectSpread(_objectSpread({
    escape: escape,
    portal: portal
  }, props), {}, {
    children: /*#__PURE__*/_jsx(ModalFullscreenView, _objectSpread(_objectSpread({
      print: print,
      theme: theme
    }, props), {}, {
      children: props.children
    }))
  }));
}